// import v-4 shims for fontawesome
import '@fortawesome/fontawesome-free/js/v4-shims.min.js';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';
import '@fortawesome/fontawesome-free/js/regular.js';
import '@fortawesome/fontawesome-free/js/fontawesome.js';
import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';

/**
 * FONT AWESOME AND SVG ICON SETUP
 */
// Setup font awesome icons
// faTimes & faCheckCircle are used in agency search from roots
// @see https://fontawesome.com/v6/docs/web/use-with/react/add-icons#add-icons-globally for info on adding ALL icons in fas package
library.add(fas);
library.add(fab);
dom.watch();
